module.exports = __webpack_public_path__ + "img/AQ.31b820ee.svg";